import React from "react";
import { Form, Input, Button, Select, InputNumber, message } from "antd";
import styles from "./styles.module.css";
import { sendEquipmentOrder } from '../../../util/auth';

const Option = Select.Option;
const { TextArea } = Input;

class AppForEquipmentForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      captchaA: 0,
      captchaB: 0,
      userCaptchaInput: "",
      isCaptchaNull: true,
    };

    this.onCaptchaChange = this.onCaptchaChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.hasErrors = this.hasErrors.bind(this);
    this.generateCaptcha = this.generateCaptcha.bind(this);
  }

  componentDidMount() {
    this.props.form.validateFields();
    this.generateCaptcha();
  }

  generateCaptcha = () => {
    const a = Math.floor(Math.random() * 20) + 1;
    const b = Math.floor(Math.random() * 20) + 1;
    this.setState({
      captchaA: a,
      captchaB: b,
      userCaptchaInput: "",
      isCaptchaNull: true,
    });
  };

  onCaptchaChange = (e) => {
    const value = e.target.value;
    const correctAnswer = this.state.captchaA + this.state.captchaB;
    const isCorrect = parseInt(value, 10) === correctAnswer;
    this.setState({
      userCaptchaInput: value,
      isCaptchaNull: !isCorrect,
    });
  };

  sendForm(opts) {
    sendEquipmentOrder(opts, () => {
      message.success("Заявка отправлена");
    });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      const isCaptchaValid = !this.state.isCaptchaNull;
      if (!err && isCaptchaValid) {
        const result = { ...values };
        const RDP = Array.isArray(values.RDP) ? values.RDP[0] : values.RDP;
        result.RDP = RDP === "Да" ? true : false;
        result.AdditionalEquipment = Array.isArray(values.AdditionalEquipment)
          ? values.AdditionalEquipment[0]
          : values.AdditionalEquipment;
        result.ConnectionType = Array.isArray(values.ConnectionType)
          ? values.ConnectionType[0]
          : values.ConnectionType;
        result.HeatMeterType = Array.isArray(values.HeatMeterType)
          ? values.HeatMeterType[0]
          : values.HeatMeterType;
        this.sendForm(result);
        this.props.form.resetFields();
        this.generateCaptcha();
      } else {
        message.warning("Не все поля заполнены верно");
      }
    });
  };

  hasErrors(fieldsError) {
    return Object.keys(fieldsError).some(field => fieldsError[field]);
  }

  validateStatusGet(name, help) {
    const { isFieldTouched, getFieldError } = this.props.form;
    const itemStatus = isFieldTouched(name) && getFieldError(name);
    let val = "";

    if (help) {
      val = itemStatus || "";
    } else {
      val = itemStatus ? "error" : "";
    }

    return val;
  }

  render() {
    const { getFieldDecorator, getFieldsError } = this.props.form;

    const formItemLayout = null;
    const tailFormItemLayout = null;

    const sendToRDP = [
      <Option key="Нет" value="Нет">Нет</Option>,
      <Option key="Да" value="Да">Да</Option>
    ];
    const heatmTypes = [
      <Option key="ВИС.Т" value="ВИС.Т">ВИС.Т</Option>,
      <Option key="КМ-5" value="КМ-5">КМ-5</Option>,
      <Option key="МАГИКА (есть шлюз)" value="МАГИКА (есть шлюз)">МАГИКА (есть шлюз)</Option>,
      <Option key="МАГИКА (нет шлюза)" value="МАГИКА (нет шлюза)">МАГИКА (нет шлюза)</Option>,
      <Option key="SA-94/2M" value="SA-94/2M">SA-94/2M</Option>,
      <Option key="SA-94/3" value="SA-94/3">SA-94/3</Option>,
      <Option key="ЭСКО-Т" value="ЭСКО-Т">ЭСКО-Т</Option>,
      <Option key="УВП-280" value="УВП-280">УВП-280</Option>,
      <Option key="ТЭМ-104" value="ТЭМ-104">ТЭМ-104</Option>,
      <Option key="ТЭМ-106" value="ТЭМ-106">ТЭМ-106</Option>,
      <Option key="РПТ-2200М" value="РПТ-2200М">РПТ-2200М</Option>,
      <Option key="ТАРАН-Т" value="ТАРАН-Т">ТАРАН-Т</Option>,
      <Option key="РПТ-1100" value="РПТ-1100">РПТ-1100</Option>,
      <Option key="ИРВИКОН" value="ИРВИКОН">ИРВИКОН</Option>,
      <Option key="ВКТ-5" value="ВКТ-5">ВКТ-5</Option>,
      <Option key="ВКТ-7" value="ВКТ-7">ВКТ-7</Option>,
      <Option key="ВЗЛЕТ-ТСР" value="ВЗЛЕТ-ТСР">ВЗЛЕТ-ТСР</Option>,
      <Option key="Логика СПТ961" value="Логика СПТ961">Логика СПТ961</Option>,
      <Option key="ТеРосс" value="ТеРосс">ТеРосс</Option>,
      <Option key="СТД" value="СТД">СТД</Option>,
      <Option key="ТЭМ-05" value="ТЭМ-05">ТЭМ-05</Option>,
      <Option key="ВТЭ-1" value="ВТЭ-1">ВТЭ-1</Option>,
      <Option key="МКТС" value="МКТС">МКТС</Option>
    ];
    const connectionTypes = [
      <Option key="GPRS" value="GPRS">GPRS</Option>,
      <Option key="Интернет" value="Интернет">Интернет</Option>,
      <Option key="Неопределен" value="Неопределен">Неопределен</Option>
    ];
    const addEquipment = [
      <Option key="связь Мегафон уверенная" value="связь Мегафон уверенная">связь Мегафон уверенная</Option>,
      <Option key="5 м" value="5 м">5 м</Option>,
      <Option key="10 м" value="10 м">10 м</Option>,
      <Option key="15 м" value="15 м">15 м</Option>,
      <Option key="20 м" value="20 м">20 м</Option>,
      <Option key="30 м" value="25 м">25 м</Option>,
      <Option key="30m" value="30 м">30 м</Option>
    ];

    return (
      <Form 
        layout="vertical" 
        onSubmit={this.handleSubmit}
        style={{ width: "46em", padding: "0em 1em 0em 1em" }}
      >
        <Form.Item
          {...formItemLayout}
          label="Название организации"
          validateStatus={this.validateStatusGet("CompanyName", false)}
          help={this.validateStatusGet("CompanyName", true)}
          className={styles.input}
        >
          {getFieldDecorator("CompanyName", {
            rules: [
              { type: "string", max: 250, message: "Неверный формат" },
              { required: true, message: "Введите название организации", whitespace: true }
            ]
          })(<Input />)}
        </Form.Item>

        <Form.Item
          {...formItemLayout}
          label={<span>Контактное лицо</span>}
          validateStatus={this.validateStatusGet("ContactPerson", false)}
          help={this.validateStatusGet("ContactPerson", true)}
          className={styles.input}
        >
          {getFieldDecorator("ContactPerson", {
            rules: [
              { type: "string", max: 250, message: "Неверный формат" },
              { required: true, message: "Вы не указали контактное лицо", whitespace: true }
            ]
          })(<Input />)}
        </Form.Item>

        <Form.Item
          {...formItemLayout}
          label="Телефон"
          validateStatus={this.validateStatusGet("PhoneNumber", false)}
          help={this.validateStatusGet("PhoneNumber", true)}
          className={styles.input}
        >
          {getFieldDecorator("PhoneNumber", {
            rules: [
              { type: "string", max: 250, message: "Неверный формат" },
              { required: true, message: "Введите телефон" }
            ]
          })(<Input />)}
        </Form.Item>

        <Form.Item
          {...formItemLayout}
          label="Ваш E-mail"
          validateStatus={this.validateStatusGet("Email", false)}
          help={this.validateStatusGet("Email", true)}
          className={styles.input}
        >
          {getFieldDecorator("Email", {
            rules: [
              { type: "email", message: "Некорректный формат" },
              { required: true, message: "Введите Ваш E-mail" }
            ]
          })(<Input />)}
        </Form.Item>

        <Form.Item
          {...formItemLayout}
          label="Тип теплосчетчика"
          validateStatus={this.validateStatusGet("HeatMeterType", false)}
          help={this.validateStatusGet("HeatMeterType", true)}
          className={styles.input}
        >
          {getFieldDecorator("HeatMeterType", {
            initialValue: ["ВИС.Т"],
            rules: [{ required: false }]
          })(<Select>{heatmTypes}</Select>)}
        </Form.Item>

        <Form.Item
          {...formItemLayout}
          label="Тип связи"
          validateStatus={this.validateStatusGet("ConnectionType", false)}
          help={this.validateStatusGet("ConnectionType", true)}
          className={styles.input}
        >
          {getFieldDecorator("ConnectionType", {
            initialValue: ["GPRS"],
            rules: [{ required: false }]
          })(<Select>{connectionTypes}</Select>)}
        </Form.Item>

        <Form.Item
          {...formItemLayout}
          label="Закупка дополнительного оборудования:
Удлинитель антенны (если нет связи)"
          validateStatus={this.validateStatusGet("AdditionalEquipment", false)}
          help={this.validateStatusGet("AdditionalEquipment", true)}
          className={styles.input}
        >
          {getFieldDecorator("AdditionalEquipment", {
            initialValue: ["связь Мегафон уверенная"],
            rules: [{ required: false }]
          })(<Select>{addEquipment}</Select>)}
        </Form.Item>

        <Form.Item
          {...formItemLayout}
          label="Адрес узла учета тепла"
          validateStatus={this.validateStatusGet("HeatMeterAddress", false)}
          help={this.validateStatusGet("HeatMeterAddress", true)}
          className={styles.input}
        >
          {getFieldDecorator("HeatMeterAddress", {
            rules: [
              { type: "string", max: 800, message: "Превышена максимальная длина" },
              { required: false, whitespace: true, message: "Одни лишь пробелы недопустимы" }
            ]
          })(<Input />)}
        </Form.Item>

        <Form.Item
          {...formItemLayout}
          label="Количество"
          validateStatus={this.validateStatusGet("Amount", false)}
          help={this.validateStatusGet("Amount", true)}
        >
          {getFieldDecorator("Amount", { initialValue: 1 })(
            <InputNumber min={0} max={10000} />
          )}
        </Form.Item>

        <Form.Item
          {...formItemLayout}
          label="ИНН"
          validateStatus={this.validateStatusGet("INN", false)}
          help={this.validateStatusGet("INN", true)}
          className={styles.input}
        >
          {getFieldDecorator("INN", {
            rules: [
              {
                type: "string",
                min: 10,
                max: 12,
                message: "Поле должно содержать 10, или 12 цифр",
                pattern: "^([0-9]{10}|[0-9]{12})$"
              },
              { required: true, message: "Вы не указали ИНН", whitespace: true }
            ]
          })(<Input />)}
        </Form.Item>

        <Form.Item
          {...formItemLayout}
          label="Дополнительные сведения"
          validateStatus={this.validateStatusGet("Comments", false)}
          help={this.validateStatusGet("Comments", true)}
          className={styles.input}
        >
          {getFieldDecorator("Comments", {
            rules: [
              { type: "string", max: 2000, message: "Превышена максимальная длина" },
              { required: false, whitespace: true, message: "Одни лишь пробелы недопустимы" }
            ]
          })(<TextArea rows={4} />)}
        </Form.Item>

        {/* Локальная математическая капча */}
        <Form.Item
          label={
            <span>
              <span style={{ color: "red" }}>*</span>
              Проверка: Сколько будет {this.state.captchaA} + {this.state.captchaB}?
            </span>
          }
          validateStatus={this.state.isCaptchaNull ? "error" : ""}
          help={this.state.isCaptchaNull ? "Решите пример" : ""}
          className={styles.input}
        >
          <Input
            value={this.state.userCaptchaInput}
            onChange={this.onCaptchaChange}
            placeholder="Введите ответ"
          />
        </Form.Item>

        <Form.Item
          {...tailFormItemLayout}
          className={styles.input}
          style={{ paddingTop: "45px" }}
        >
          <Button
            type="primary"
            htmlType="submit"
            disabled={
              this.hasErrors(getFieldsError()) || this.state.isCaptchaNull
            }
            style={{ marginRight: "1em", float: "right" }}
          >
            Отправить
          </Button>
        </Form.Item>
      </Form>
    );
  }
}

const WrappedAppForEquipmentForm = Form.create({ name: "horizontal_login" })(
  AppForEquipmentForm
);

export default WrappedAppForEquipmentForm;